<lib-modal-layout [title]="'Start a Quote'" [subtitle]="''">
  <p class="text-center large">Select a program to begin your quote.</p>
  <div class="flex flex-col items-center justify-center gap-3 my-4">
    @for (program of programs(); track program.routingUrl) {
      <lib-button
        [cssType]="'btn-primary'"
        [text]="program.heading || 'Program'"
        [size]="'large'"
        [icon]="'rightarrow'"
        (click)="select(program.routingUrl)"
      ></lib-button>
    }
  </div>
</lib-modal-layout>
